'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var errCode = require('err-code');

var parallel = require('it-parallel');

var map = require('it-map');

var filter = require('it-filter');

var itPipe = require('it-pipe');

var utils = require('./utils.js');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var parallel__default = /*#__PURE__*/_interopDefaultLegacy(parallel);

var map__default = /*#__PURE__*/_interopDefaultLegacy(map);

var filter__default = /*#__PURE__*/_interopDefaultLegacy(filter);

var BLOCK_RM_CONCURRENCY = 8;

function createRm(_ref) {
  var repo = _ref.repo;

  function rm(_x) {
    return _rm.apply(this, arguments);
  }

  function _rm() {
    _rm = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cids) {
      var options,
          release,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

              if (!Array.isArray(cids)) {
                cids = [cids];
              }

              _context2.next = 4;
              return _awaitAsyncGenerator(repo.gcLock.writeLock());

            case 4:
              release = _context2.sent;
              _context2.prev = 5;
              return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(itPipe.pipe(cids, function (source) {
                return map__default["default"](source, function (cid) {
                  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var result, has;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            cid = utils.cleanCid(cid);
                            result = {
                              cid: cid
                            };
                            _context.prev = 2;
                            _context.next = 5;
                            return repo.blocks.has(cid);

                          case 5:
                            has = _context.sent;

                            if (has) {
                              _context.next = 8;
                              break;
                            }

                            throw errCode__default["default"](new Error('block not found'), 'ERR_BLOCK_NOT_FOUND');

                          case 8:
                            _context.next = 10;
                            return repo.blocks.delete(cid);

                          case 10:
                            _context.next = 15;
                            break;

                          case 12:
                            _context.prev = 12;
                            _context.t0 = _context["catch"](2);

                            if (!options.force) {
                              _context.t0.message = "cannot remove ".concat(cid, ": ").concat(_context.t0.message);
                              result.error = _context.t0;
                            }

                          case 15:
                            return _context.abrupt("return", result);

                          case 16:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[2, 12]]);
                  }));
                });
              }, function (source) {
                return parallel__default["default"](source, BLOCK_RM_CONCURRENCY);
              }, function (source) {
                return filter__default["default"](source, function () {
                  return !options.quiet;
                });
              })), _awaitAsyncGenerator), "t0", 7);

            case 7:
              _context2.prev = 7;
              release();
              return _context2.finish(7);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[5,, 7, 10]]);
    }));
    return _rm.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(rm);
}

exports.createRm = createRm;